module.exports = __webpack_public_path__ + "static/media/delete-icon-1.09de56ba.svg";